import { authenticatedFetchJson } from "@/services/utils/authenticatedFetch";

interface MultiadapterCredentials {
  username: string;
  password: string;
  apiUrl: string;
}

export async function saveMultiadapterCredentials(
  username: string,
  password: string,
  apiUrl: string
): Promise<MultiadapterCredentials> {
  try {
    const data = await authenticatedFetchJson<MultiadapterCredentials>("/api/multiadapter-credentials", {
      method: "POST",
      body: JSON.stringify({ username, password, apiUrl }),
    });

    return {
      username: data.username || username,
      password: data.password || password,
      apiUrl: data.apiUrl || apiUrl
    };
  } catch (error) {
    console.error("Error saving Multiadapter credentials:", error);
    throw error;
  }
}
